import { atom } from "jotai";

export const bookingCourtAtom = atom<{
  id: string;
  name: string;
  description: string;
  maxDurationMins: number;
  startSlotId: string;
} | null>(null);
